import request from "@/router/exhibitor/request";
import logo from "@/router/exhibitor/logo";
import profile from "@/router/exhibitor/profile";
import help from "@/router/exhibitor/help";
import wine from "@/router/exhibitor/wine";
import page from "@/router/exhibitor/page";

export default [...page, ...wine, ...request, ...logo, ...profile, ...help];
